/* tslint:disable:max-classes-per-file */
import React from 'react';
import { Routing, Utils } from '@singularsystems/neo-core';
import { NavLink } from 'react-router-dom';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import Scrollbar from 'react-custom-scrollbars';
import { AppService, Types } from '../Services/AppService';
import { IAppLayout, ScreenSize } from '../Services/AppLayout';

@observer
class Sidebar extends React.Component {

    private routeService = AppService.get(Types.Services.RouteService);
    private appLayout = AppService.get(Types.Services.AppLayout);
    private config = AppService.get(Types.Config);

    private menuContainer: React.RefObject<HTMLDivElement>;

    constructor(props: any) {
        super(props);

        this.menuContainer = React.createRef<HTMLDivElement>();
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
    }

    private mouseEnter() {
        this.appLayout.menuHover(true);
    }
    private mouseLeave() {
        this.appLayout.menuHover(false);
    }

    public render() {
        const layout = this.appLayout;
        const applicationVersion = this.config.applicationVersion;

        const menuItemProvider = AppService.get(Types.Neo.Routing.MenuItemProvider);
        const menuItems = menuItemProvider.processRoutes(this.routeService.routes.menuRoutes, { collapseSingle: true, hideWhenEmpty: true });

        return (
            <div>
                <div ref={this.menuContainer}
                    id="left-panel"
                    className="app-left-panel"
                    onMouseEnter={this.mouseEnter}
                    onMouseLeave={this.mouseLeave}>

                    <div className="sidebar">
                        <div className="sidebar-header">
                            <div className="Logo" />
                        </div>

                        <div className="sidebar-content">
                            {/* Full screen menu */}
                            {layout.currentScreenSize === ScreenSize.Huge &&
                                <Scrollbar height="100%" hideTracksWhenNotNeeded>
                                    <Menu items={menuItems} level={1} appLayout={this.appLayout} applicationVersion={applicationVersion} />
                                </Scrollbar>}

                            {/* Small screen menu */}
                            {layout.currentScreenSize !== ScreenSize.Huge &&
                                <Menu items={menuItems} level={1} appLayout={this.appLayout} applicationVersion={applicationVersion} />}                            
                        </div>
                    </div>
                </div>

            </div>

        );
    }
}

interface IMenuProps {
    appLayout: IAppLayout;
    items: Routing.IMenuRoute[];
    level: number;
    applicationVersion: string;
}

@observer
class Menu extends React.Component<IMenuProps> {

    public render() {

        return (
            <>
                {this.props.level === 1 && <div className='versionNumberSideBar'>
                   Version - {this.props.applicationVersion}
                </div> }
                <ul className={"menu-level-" + this.props.level}>
                    {this.props.items.map(item => <MenuItem key={item.path || item.name} item={item} level={this.props.level} appLayout={this.props.appLayout} applicationVersion={this.props.applicationVersion} />)}
                </ul>
                
            </>
        )
    }
}

interface IMenuItemProps {
    appLayout: IAppLayout;
    item: Routing.IMenuRoute;
    level: number;
    applicationVersion: string;
}

@observer
class MenuItem extends React.Component<IMenuItemProps> {

    @observable.ref
    public isExpanded = false;

    constructor(props: IMenuItemProps) {
        super(props);

        if (props.item.children && props.item.expanded) {
            this.isExpanded = true;
        }

        this.onExpanderClick = this.onExpanderClick.bind(this);
    }

    private onExpanderClick(e: React.MouseEvent<HTMLSpanElement, MouseEvent>) {
        if (this.props.item.children) {
            e.stopPropagation();
            e.preventDefault();

            this.isExpanded = !this.isExpanded;
        }
    }

    public render() {
        const item = this.props.item;
        const hasChildren = !!item.children;

        let fakeIconText = "";
        if (!item.icon) {
            let matches = item.name.match(/\b(\w)/g);
            let acronym = matches?.join('');
            if (acronym) {
                fakeIconText = acronym.substr(0, 2);
            }
        }

        let icon = item.icon ? <i className={"sidebar-icon fa-fw " + Utils.getFontAwesomeClass(item.icon)} /> : <span className="sidebar-icon fake-icon">{fakeIconText}</span>;
        let text = <span className="menu-item-text">{item.name}</span>;

        return (
            <li>
                <div onClick={this.onExpanderClick} className={"menu-item" + (hasChildren ? " has-children" : "")}>

                    {/* {item.path ?
                        <NavLink className="sidebar-icon-container" exact={!item.routeChildren} to={item.path}>{item.icon && <i className={"fa-fw " + Utils.getFontAwesomeClass(item.icon)} />} <div className="responsive-hidden">{item.name}</div></NavLink> :
                        <span>{item.icon && <i className={"fa-fw " + Utils.getFontAwesomeClass(item.icon)} />} <div className="responsive-hidden">{item.name}</div></span>
                    } */}
                    {item.path ?
                        <NavLink exact={!hasChildren || this.isExpanded} to={item.path}>
                            <div className="sidebar-icon-container" onClick={this.onExpanderClick}>
                                {icon}
                                {hasChildren && <div className="sidebar-mini-expander">
                                    <i className={"fa fa-" + (this.isExpanded ? "caret-down" : "caret-right")} />
                                </div>}
                            </div> {text}
                        </NavLink> :
                        <span className="static-item" onClick={this.onExpanderClick}>
                            {icon} {text}
                        </span>
                    }

                    {hasChildren &&
                        <div className={"menu-expander " + (this.isExpanded ? "expanded" : "collapsed")} onClick={this.onExpanderClick}>
                            <i className={"fa fa-" + (this.isExpanded ? "caret-down" : "caret-right")} />
                        </div>
                    }
                </div>

                {this.isExpanded && item.children && <Menu items={item.children} level={this.props.level + 1} appLayout={this.props.appLayout} applicationVersion={this.props.applicationVersion} />}
            </li>)
    }
}

export default Sidebar;